import { useQuery } from '@tanstack/react-query'

import { IUseDataQueryParams, TracingResponse } from '../types/Api'
import { queryDataHandler } from '../utils/queryDataHandler'

const useTableDataQuery = (
  {
    nameOfFile,
    paginationModel,
    sort,
    appliedUniqueColumns,
    appliedFilters,
    known,
  }: IUseDataQueryParams,
  options: any
) => {
  return useQuery<TracingResponse, Error>({
    enabled: options?.enabled,
    queryKey: [
      'table-data',
      appliedFilters,
      appliedUniqueColumns,
      paginationModel,
      sort,
      nameOfFile,
      known,
    ],
    queryFn: () =>
      queryDataHandler({
        nameOfFile,
        paginationModel,
        sort,
        appliedUniqueColumns,
        appliedFilters,
        known,
      }),
    staleTime: 5 * 60 * 1000,
    placeholderData: nameOfFile ? (previousData: any) => previousData : undefined,
  })
}

export default useTableDataQuery
